import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { TranslationProvider } from '@/contexts/TranslationContext';
import HomePage from '@/pages/HomePage';
import BecomeSponsorPage from '@/pages/BecomeSponsorPage';
import BecomeHostPage from '@/pages/BecomeHostPage';
import FundraisingLandingPage from '@/pages/FundraisingLandingPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';

function App() {
  return (
    <TranslationProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/become-sponsor" element={<BecomeSponsorPage />} />
            <Route path="/become-host" element={<BecomeHostPage />} />
            <Route path="/fundraising" element={<FundraisingLandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </TranslationProvider>
  );
}

export default App;
